import { useEffect, useRef, useState } from 'react';
import { reserveAdminWorkAvailabilityPrompt, acknowledgeAdminWorkAvailabilityPrompt } from '../../../api/workAvailability';
import { WorkAvailabilityPromptLifecycle } from '../../../utils/workAvailabilityPromptLifecycle';

export type PromptReservation = Awaited<ReturnType<typeof reserveAdminWorkAvailabilityPrompt>>;

export function useWorkAvailabilityPrompt(identity: string | number | null) {
  const [claim, setClaim] = useState<PromptReservation | null>(null);
  const lifecycle = useRef<WorkAvailabilityPromptLifecycle<PromptReservation> | null>(null);
  useEffect(() => {
    setClaim(null);
    if (identity == null) return;
    const controller = new WorkAvailabilityPromptLifecycle({
      reserve: reserveAdminWorkAvailabilityPrompt, acknowledge: acknowledgeAdminWorkAvailabilityPrompt,
      present: setClaim, hide: () => setClaim(null),
    });
    lifecycle.current = controller;
    const visible = () => controller.setActive(document.visibilityState !== 'hidden');
    const invalidate = () => controller.invalidate();
    visible();
    document.addEventListener('visibilitychange', visible);
    window.addEventListener('focus', visible);
    window.addEventListener('casticart:work-availability-updated', invalidate);
    return () => {
      controller.dispose();
      lifecycle.current = null;
      document.removeEventListener('visibilitychange', visible);
      window.removeEventListener('focus', visible);
      window.removeEventListener('casticart:work-availability-updated', invalidate);
    };
  }, [identity]);
  return { claim, setClaim, close: () => lifecycle.current?.close(), presented: () => lifecycle.current?.presented() };
}
